import { Typography } from 'antd';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
};

const CreateMultipleEnsModal = ({ open, onConfirm, onClose }: Props) => {
    return (
        <ConfirmationModal
            width={600}
            open={open}
            title="Create Multiple ENS"
            confirmButtonText="Create ENS"
            onCancel={onClose}
            onClose={onClose}
            onConfirm={onConfirm}
            content={
                <Typography.Text>
                    This accompanied manifest includes multiple jobs. An ENS is required per job, so multiple ENS
                    fillings will be created.
                </Typography.Text>
            }
        />
    );
};

export default CreateMultipleEnsModal;
